<template>
    <div>
        <!--导航栏 start-->
        <van-nav-bar
                title="商户进件"
                left-text="返回"
                @click-left="onClickLeft"
                left-arrow
                fixed
        />
        <!--导航栏 end -->
        <div style="margin-top: 1.5rem">
            <!--表单 start-->
            <van-form class="form_box" @submit="onSubmit" validate-first @failed="onFailed">
                <!--商户码 start-->
                <van-cell class="pay_code" title="商户码" :value="form.extData.payCode" size="large"/>
                <!--商户码 end-->

                <!--信息填报 start-->
                <van-collapse v-model="activeNames">
                    <!--基础信息 start-->
                    <van-collapse-item title="基础信息" icon="shop-o" name="1">

                        <!--商户类型 ok start-->
                        <van-field
                                readonly
                                clickable
                                name="paper.merchantType"
                                :rules="[{ required: true, message: '商户类型必选' }]"
                                :value="merchantTypeValue"
                                label="商户类型"
                                placeholder="点击选择商户类型"
                                @click="showMerchantTypePicker = true"
                        />
                        <van-popup v-model="showMerchantTypePicker" position="bottom">
                            <van-picker
                                    show-toolbar
                                    :columns="merchantType"
                                    default-index="0"
                                    @confirm="onMerchantTypeConfirm"
                                    @cancel="showMerchantTypePicker = false"
                            />
                        </van-popup>
                        <!--商户类型 end-->

                        <!--营业执照证照 ok start-->
                        <van-field v-if="form.paper.merchantType==1 || form.paper.merchantType==2"
                                   name="paper.businessLicensePhoto" label="营业执照证照">
                            <template #input>
                                <img class="photo" :src="imgs.businessLicensePhoto" alt=""
                                     @click="openPhoto('businessLicensePhoto')">
                            </template>
                        </van-field>
                        <!--营业执照证照 end-->

                        <!--商户全称 ok start-->
                        <van-field
                                v-if="form.paper.merchantType==1 || form.paper.merchantType==2"
                                clearable
                                v-model="form.paper.businessLicenseName"
                                name="merchantName"
                                label="商户全称"
                                type="textarea"
                                autosize
                                maxlength="40"
                                show-word-limit
                                rows="2"
                                placeholder="2-40个字，与营业执照名称一致"
                                :rules="[{ required: true, message: '商户全称必须填写' }]"
                        />
                        <!--商户全称 end-->

                        <!--营业执照号 ok start-->
                        <van-field
                                v-if="form.paper.merchantType==1 || form.paper.merchantType==2"
                                clearable
                                v-model="form.paper.businessLicenseCode"
                                name="paper.merchantName"
                                label="营业执照号"
                                type="textarea"
                                autosize
                                maxlength="40"
                                show-word-limit
                                rows="2"
                                placeholder="请输入营业执照号"
                                :rules="[{ required: true, message: '营业执照号必须填写' }]"
                        />
                        <!--营业执照号 end-->

                        <!--营业执照有效期 start-->
                        <van-row v-if="form.paper.merchantType==1 || form.paper.merchantType==2">
                            <van-col span="18">
                                <van-field
                                        readonly
                                        clickable
                                        name="paper.businessLicenseExpired"
                                        :value="form.paper.businessLicenseExpired"
                                        label="证件结束时间"
                                        placeholder="点击选择证件结束时间"
                                        @click="showLicenseEndPickerClick()"
                                />

                                <van-popup v-model="showLicenseEndPicker" position="bottom">
                                    <van-datetime-picker
                                            type="date"
                                            :max-date="maxDate"
                                            :disabled="showLicenseEndPicker"
                                            style="padding-top: 10px"
                                            @confirm="onLicenseEndConfirm"
                                            @cancel="showLicenseEndPicker = false"
                                    />
                                </van-popup>

                            </van-col>
                            <van-col span="6" style="padding-top: 12px;">
                                <van-checkbox v-model="isLicenseEnd">长期</van-checkbox>
                            </van-col>
                        </van-row>
                        <!--营业执照有效期 end-->


                        <!--行业类目 ok start-->
                        <van-field
                                readonly
                                clickable
                                name="paper.industryCategoryId"
                                :rules="[{ required: true, message: '行业类目必选' }]"
                                :value="industryCategoryIdValue"
                                label="行业类目"
                                placeholder="点击选择行业类目"
                                @click="showIndustryCategoryIdPicker = true"
                        />
                        <van-popup v-model="showIndustryCategoryIdPicker" position="bottom">
                            <van-picker
                                    show-toolbar
                                    :columns="industryCategoryId"
                                    default-index="0"
                                    title="行业类目"
                                    @confirm="onIndustryCategoryIdConfirm"
                                    @cancel="showIndustryCategoryIdPicker = false"
                            />
                        </van-popup>
                        <!--行业类目 end-->

                        <!--经营所在省市区 start-->
                        <van-field
                                readonly
                                clickable
                                name="addressInfo.provinceCode_cityCode_areaCode"
                                :rules="[{ required: true, message: '省区县必选' }]"
                                :value="form.provinceCode_cityCode_areaCode"
                                label="经营地址省区县"
                                placeholder="点击选经营地址省区县"
                                @click="showAddressPicker = true"
                        />
                        <van-popup v-model="showAddressPicker" position="bottom">

                            <van-area :area-list="unionArea" @confirm="onAddressConfirm"
                                      @cancel="showAddressPicker = false" :columns-num="3" title="经营所在省市区"/>

                        </van-popup>
                        <!--经营所在省市区 start-->

                        <!--经营地址 start-->
                        <van-field
                                v-model="form.paper.businessAddress"
                                name="pager.businessAddress"
                                label="经营地址"
                                placeholder="有营业执照必须与经营地址一致"
                        />
                        <!--经营地址 end-->


                        <!--法人姓名 ok start-->
                        <van-field
                                clearable
                                v-model="form.paper.lawyerName"
                                name="lawyerName"
                                label="法人姓名"
                                type="text"
                                placeholder="请输入法人姓名"
                                :rules="[{ required: true, message: '法人姓名必须填写' }]"
                        />
                        <!--法人姓名 end-->

                        <!--法人证件号码 ok start-->
                        <van-field
                                clearable
                                v-model="form.paper.lawyerCertNo"
                                name="lawyerName"
                                label="法人证件号码"
                                type="text"
                                placeholder="请输入法人证件号码"
                                :rules="[{ required: true, message: '法人证件号码必须填写' }]"
                        />
                        <!--法人证件号码 end-->

                        <!--法人证件正面照 ok start-->
                        <van-field name="paper.lawyerCertPhotoFront" label="法人证件正面照">
                            <template #input>
                                <img class="photo" :src="imgs.lawyerCertPhotoFront" alt=""
                                     @click="openPhoto('lawyerCertPhotoFront')">
                            </template>
                        </van-field>
                        <!--法人证件正面照 end-->

                        <!--法人证件背面照 ok start-->
                        <van-field name="paper.lawyerCertPhotoBack" label="法人证件背面照">
                            <template #input>
                                <img class="photo" :src="imgs.lawyerCertPhotoBack" alt=""
                                     @click="openPhoto('lawyerCertPhotoBack')">
                            </template>
                        </van-field>
                        <!--法人证件背面照 end-->


                        <!--联系人姓名 start-->
                        <van-field
                                v-model="form.paper.contactPerson"
                                name="pager.contactPerson"
                                label="联系人姓名"
                                placeholder="请输入联系人姓名"
                                :rules="[{ required: true, message: '联系人姓名必须填写' }]"
                        />
                        <!--联系人姓名 end-->

                        <!--联系人手机号码 start-->
                        <van-field
                                v-model="form.paper.contactPhone"
                                name="pager.contactPhone"
                                label="联系人手机号码"
                                placeholder="请输入联系人手机号码"
                                :rules="[{ required: true, message: '联系人手机号码必须填写' }]"
                        />
                        <!--联系人手机号码 end-->

                        <!--客服电话 start-->
                        <van-field
                                v-model="form.paper.serviceTel"
                                name="pager.serviceTel"
                                label="客服电话"
                                placeholder="请输入客服电话"
                                :rules="[{ required: true, message: '客服电话必须填写' }]"
                        />
                        <!--客服电话 end-->

                        <!--邮箱地址 start-->
                        <van-field
                                v-model="form.paper.email"
                                name="pager.email"
                                label="邮箱地址"
                                placeholder="请输入邮箱地址"
                                :rules="[{ required: true, message: '邮箱地址必须填写' }]"
                        />
                        <!--邮箱地址 end-->


                        <!--门店门头照 ok start-->
                        <van-field name="paper.storeHeadPhoto" label="门店门头照">
                            <template #input>
                                <img class="photo" :src="imgs.storeHeadPhoto" alt=""
                                     @click="openPhoto('storeHeadPhoto')">
                            </template>
                        </van-field>
                        <!--门店门头照 end-->

                        <!--门店外景照 ok start-->
                        <van-field name="paper.storeHeadPhoto" label="门店外景照">
                            <template #input>
                                <img class="photo" :src="imgs.storeShopPhoto" alt=""
                                     @click="openPhoto('storeShopPhoto')">
                            </template>
                        </van-field>
                        <!--门店外景照 end-->

                        <!--门店内景照 ok start-->
                        <van-field name="paper.storeHeadPhoto" label="门店内景照">
                            <template #input>
                                <img class="photo" :src="imgs.storeHallPhoto" alt=""
                                     @click="openPhoto('storeHallPhoto')">
                            </template>
                        </van-field>
                        <!--门店内景照 end-->

                        <!--门店收银台照 ok start-->
                        <van-field name="paper.storeCashierPhoto" label="门店收银台照">
                            <template #input>
                                <img class="photo" :src="imgs.storeCashierPhoto" alt=""
                                     @click="openPhoto('storeCashierPhoto')">
                            </template>
                        </van-field>
                        <!--门店收银台照 end-->


                    </van-collapse-item>
                    <!--基础信息 end-->

                    <!--商户结算信息 start-->
                    <van-collapse-item title="商户结算信息" icon="shop-o" name="2">

                        <!--结算账户类型 ok start-->
                        <van-field
                                readonly
                                clickable
                                name="paper.settleAccountType"
                                :rules="[{ required: true, message: '结算账户类型必选' }]"
                                :value="settleAccountTypeValue"
                                label="结算账户类型"
                                placeholder="点击选择结算账户类型"
                                @click="settleAccountTypePicker = true"
                        />
                        <van-popup v-model="settleAccountTypePicker" position="bottom">
                            <van-picker
                                    show-toolbar
                                    :columns="settleAccountType"
                                    @confirm="onSettleAccountTypePickerConfirm"
                                    @cancel="settleAccountTypePicker = false"
                            />
                        </van-popup>
                        <!--结算账户类型 end-->

                        <!--结算户号 ok start-->
                        <van-field
                                clearable
                                v-model="form.paper.settleAccountNo"
                                name="paper.settleAccountNo"
                                label="结算户号"
                                placeholder="请输入结算户号"
                                :rules="[{ required: true, message: '结算户号必须填写' }]"
                        />
                        <!--结算户号 end-->

                        <!--结算户名 ok start-->
                        <van-field
                                clearable
                                v-model="form.paper.settleAccount"
                                name="settleAccount"
                                label="结算户名"
                                placeholder="请输入结算户名"
                                :rules="[{ required: true, message: '结算户名必须填写' }]"
                        />
                        <!--结算户名 end-->

                        <!--开户许可证（照片） ok start-->
                        <van-field v-if="form.paper.settleAccountType==1" name="paper.openingLicenseAccountPhoto"
                                   label="开户许可证">
                            <template #input>
                                <img class="photo" :src="imgs.openingLicenseAccountPhoto" alt=""
                                     @click="openPhoto('openingLicenseAccountPhoto')">
                            </template>
                        </van-field>
                        <!--开户许可证（照片） end-->

                        <!--结算授权书  ok start-->
                        <van-field v-if="form.paper.settleAccountType==3"
                                   name="paper.settleAuthLetterPhoto" label="结算授权书">
                            <template #input>
                                <img class="photo" :src="imgs.settleAuthLetterPhoto" alt=""
                                     @click="openPhoto('settleAuthLetterPhoto')">
                            </template>
                        </van-field>
                        <!--结算授权书  end-->

                        <!--银行卡正面照  ok start-->
                        <van-field v-if="form.paper.settleAccountType==2 || form.paper.settleAccountType==3"
                                   name="paper.bankCardPhotoFront" label="商户收单协议照片">
                            <template #input>
                                <img class="photo" :src="imgs.acquiringAgreementPhoto" alt=""
                                     @click="openPhoto('acquiringAgreementPhoto')">
                            </template>
                        </van-field>
                        <!--银行卡正面照  end-->

                        <!--开户银行 ok start-->
                        <van-field
                                clearable
                                v-model="form.openBank"
                                name="openBank"
                                label="开户银行"
                                placeholder="请输入开户银行"
                                :rules="[{ required: true, message: '开户银行必须填写' }]"
                        />
                        <!--开户银行 end-->

                        <!--银行网点-省 start-->
                        <van-field
                                readonly
                                clickable
                                :rules="[{ required: true, message: '银行网点-省' }]"
                                :value="provinceBanksVal"
                                label="银行网点-省"
                                placeholder="点击选择银行网点-省"
                                @click="showProvinceBanksPicker = true"
                        />
                        <van-popup v-model="showProvinceBanksPicker" position="bottom">
                            <van-picker
                                    show-toolbar
                                    :columns="provinceBanks"
                                    @confirm="onProvinceBanksConfirm"
                                    @cancel="showProvinceBanksPicker = false"
                            />
                        </van-popup>
                        <!--银行网点省 end-->
                        <!--银行网点市 start-->
                        <van-field
                                readonly
                                clickable
                                :rules="[{ required: true, message: '银行网点-市' }]"
                                :value="cityBanksVal"
                                label="银行网点-市"
                                placeholder="点击选择银行网点-市"
                                @click="showCityBanksPicker = true"
                        />
                        <van-popup v-model="showCityBanksPicker" position="bottom">
                            <van-picker
                                    show-toolbar
                                    :columns="cityBanks"
                                    @confirm="onCityBanksConfirm"
                                    @cancel="showCityBanksPicker = false"
                            />
                        </van-popup>
                        <!--银行网点市 end-->

                        <!--开户支行 ok start-->
                        <van-field
                                readonly
                                clickable
                                name="paper.openSubBank"
                                :rules="[{ required: true, message: '开户支行必选' }]"
                                :value="openSubBankValueText"
                                label="开户支行"
                                placeholder="模糊搜索银行分行网点"
                                @click="showOpenSubBankPicker = true"
                        />
                        <van-popup round v-model="showOpenSubBankPicker" position="bottom" :style="{ height: '80%' }">
                            <van-search v-model="openSubBankValue" placeholder="请输入银行关键词"/>
                            <van-cell @click="banksSelected(item)" clickable v-bind:key="key"
                                      v-for="(item,key) in banksData" :value="item.address"/>
                        </van-popup>
                        <!--开户支行 end-->

                        <!--银行预留手机号 ok start-->
                        <van-field
                                clearable
                                v-model="form.paper.openBankReservePhone"
                                name="paper.openBankReservePhone"
                                label="银行预留手机号"
                                placeholder="请输入银行预留手机号"
                                :rules="[{ required: true, message: '银行预留手机号必须填写' }]"
                        />
                        <!--银行预留手机号 end-->

                        <!--被授权人身份证号码  ok start-->
                        <van-field
                                v-if="form.paper.settleAccountType==3"
                                clearable
                                v-model="form.paper.authorizedPersonCertNo"
                                name="paper.authorizedPersonCertNo"
                                label="被授权人身份证号码"
                                placeholder="请输入被授权人身份证号码"
                                :rules="[{ required: true, message: '银行预留手机号必须填写' }]"
                        />
                        <!--被授权人证件号码  end-->

                        <!--被授权人证件正面照  ok start-->
                        <van-field v-if="form.paper.settleAccountType==3"
                                   name="paper.authorizedCertPhotoFront" label="被授权人证件正面照">
                            <template #input>
                                <img class="photo" :src="imgs.authorizedCertPhotoFront" alt=""
                                     @click="openPhoto('authorizedCertPhotoFront')">
                            </template>
                        </van-field>
                        <!--被授权人证件正面照  end-->

                        <!--被授权人证件正面照  ok start-->
                        <van-field v-if="form.paper.settleAccountType==3"
                                   name="paper.authorizedCertPhotoBack" label="被授权人证件背面照">
                            <template #input>
                                <img class="photo" :src="imgs.authorizedCertPhotoBack" alt=""
                                     @click="openPhoto('authorizedCertPhotoBack')">
                            </template>
                        </van-field>
                        <!--被授权人证件正面照  end-->


                        <!--T0费率 ok start-->
                        <van-field
                                type="number"
                                clearable
                                show-word-limit
                                v-model="form.rate.t0"
                                name="rate.t0"
                                label="T0费率"
                                placeholder="请填T0费率"
                                :rules="[{ required: true, message: 'T0费率必须填写' }]"
                        />
                        <!--T0费率 end-->


                        <!--T1费率 ok start-->
                        <van-field
                                type="number"
                                clearable
                                show-word-limit
                                v-model="form.rate.t1"
                                name="rate.t1"
                                label="T1费率"
                                placeholder="请填T1费率"
                                :rules="[{ required: true, message: 'T1费率必须填写' }]"
                        />
                        <!--T1费率 end-->

                        <!--D0费率 ok start-->
                        <van-field
                                type="number"
                                clearable
                                show-word-limit
                                v-model="form.rate.d0"
                                name="rate.d0"
                                label="D0费率"
                                placeholder="请填D0费率"
                                :rules="[{ required: true, message: 'D0费率必须填写' }]"
                        />
                        <!--D0费率 end-->

                        <!--D1费率 ok start-->
                        <van-field
                                type="number"
                                clearable
                                show-word-limit
                                v-model="form.rate.d1"
                                name="rate.d1"
                                label="D1费率"
                                placeholder="请填D1费率"
                                :rules="[{ required: true, message: 'D1费率必须填写' }]"
                        />
                        <!--D1费率 end-->

                        <!--银行卡小于1000费率 ok start-->
                        <van-field
                                type="number"
                                clearable
                                v-model="form.rate.bankCardRateLevel2.feeRateUnionpayDebit"
                                name="rate.bankCardRateLevel2.feeRateUnionpayDebit"
                                label="银行卡小于1000费率"
                                placeholder="请填银行卡小于1000费率"
                                :rules="[{ required: true, message: '银行卡小于1000费率必须填写' }]"
                        />
                        <!--银行卡小于1000费率 end-->

                        <!--银行卡大于1000费率 ok start-->
                        <van-field
                                clearable
                                v-model="form.rate.bankCardRateLevel1.feeRateUnionpayDebit"
                                name="rate.bankCardRateLevel1.feeRateUnionpayDebit"
                                label="银行卡大于1000费率"
                                type="number"
                                placeholder="请填银行卡大于1000费率"
                                :rules="[{ required: true, message: '银行卡大于1000费率必须填写' }]"
                        />
                        <!--银行卡大于1000费率 end-->


                    </van-collapse-item>
                    <!--商户结算信息 end-->

                </van-collapse>
                <!--信息填报 end-->

                <!--提交按钮-->
                <div style="margin: 16px;">
                    <van-button round block type="info" native-type="submit">
                        提交
                    </van-button>
                </div>
                <!--提交按钮-->

            </van-form>
            <!--表单 end-->
        </div>
    </div>

</template>

<script>
    import UnionArea from '@/assets/json/leshuazf_area'
    import {Toast, Dialog, Notify} from 'vant';
    import VueCookie from 'vue-cookies'
    import wx from 'weixin-js-sdk'
    import phone_upload_img from '@/assets/images/phone_upload.png'
    import Config from '@/config'

    export default {
        name: "union",
        data() {
            return {
                //收缩
                activeNames: ['2'],
                //商户类型
                merchantType: [],
                //是否显示商户类型选择
                showMerchantTypePicker: false,
                //商户类型
                merchantTypeValue: '',
                //商户MCC
                industryCategoryId: [],
                //是否显示商户MCC选择
                showIndustryCategoryIdPicker: false,
                //商户MCC选中文本
                industryCategoryIdValue: "",
                //银联区域
                unionArea: UnionArea,
                //是否显示地址
                showAddressPicker: false,
                //省市区
                provinceCode_cityCode_areaCode: "",
                //最大日期
                maxDate: new Date(2099, 12, 31),
                //营业执照是否是长期
                isLicenseEnd: false,
                //营业执照结束日期选择
                showLicenseEndPicker: false,
                //结算账户类型
                settleAccountType: [],
                //结算账号账户类型picker
                settleAccountTypePicker: false,
                //结算账户类型值
                settleAccountTypeValue: "",
                //模糊查询银行列表数据
                banksData: [],
                //银行支行选择器
                showOpenSubBankPicker: false,
                //开户支行值
                openSubBankValue: "",
                //开户支行显示值
                openSubBankValueText: "",
                //银行网点省
                provinceBanks: [],
                //银行网点市
                cityBanks: [],
                //银行网点省值
                provinceBanksVal: "",
                //银行网点市值
                cityBanksVal: "",
                //银行网点-picker
                showProvinceBanksPicker: false,
                //银行网点市-picker
                showCityBanksPicker: false,
                //照片资料
                imgs: {
                    //营业执照
                    businessLicensePhoto: phone_upload_img,
                    //法人证件正面照
                    lawyerCertPhotoFront: phone_upload_img,
                    //法人证件背面照
                    lawyerCertPhotoBack: phone_upload_img,
                    //开户许可证
                    openingLicenseAccountPhoto: phone_upload_img,
                    //商户收单协议照片
                    acquiringAgreementPhoto: phone_upload_img,
                    //结算授权书
                    settleAuthLetterPhoto: phone_upload_img,
                    //门店门头照
                    storeHeadPhoto: phone_upload_img,
                    //门店外景照
                    storeShopPhoto: phone_upload_img,
                    //门店内景照
                    storeHallPhoto: phone_upload_img,
                    //门店收银台照
                    storeCashierPhoto: phone_upload_img
                },
                //提交表单
                form: {
                    //商户注册的名称
                    merchantName: "",
                    //进件详细信息
                    paper: {
                        //商户类型 (1：个体工商户 2：企业 3：个人)
                        merchantType: "",
                        //营业执照号 (长度：9—21 merchantType= 1、2 必传)
                        businessLicenseCode: "",
                        //注：与营业执照上登记注册的名称一致merchantType= 1、2 必传
                        businessLicenseName: "",
                        //--营业执照照片 (merchantType= 1、2 必传)
                        businessLicensePhoto: "",
                        //营业执照有效期(merchantType= 1、2 必传)
                        businessLicenseExpired: "",
                        //行业类目
                        industryCategoryId: "",
                        //经营地址
                        businessAddress: "",
                        //省
                        province: "",
                        //市
                        city: "",
                        //区
                        area: "",
                        //门店门头照
                        storeHeadPhoto: "",
                        //门店外景照
                        storeShopPhoto: "",
                        //门店内景照
                        storeHallPhoto: "",
                        //门店收银台照
                        storeCashierPhoto: "",
                        //法人姓名
                        lawyerName: "",
                        //法人证件类型
                        lawyerCertType: 1,
                        //法人证件号码
                        lawyerCertNo: "",
                        //法人证件正面照
                        lawyerCertPhotoFront: "",
                        //法人证件背面照
                        lawyerCertPhotoBack: "",
                        //联系人姓名
                        contactPerson: "",
                        //联系人手机号码
                        contactPhone: "",
                        //客服电话
                        serviceTel: "",
                        //邮箱地址
                        email: "",
                        //结算账户类型 （1：对公账户 2：法人账户 3：被授权人账户）
                        settleAccountType: "",
                        //结算户号
                        settleAccountNo: "",
                        //结算户名
                        settleAccount: "",
                        //结算周期(结算周期(1：T+1；2：D+0; 3:T+0 4:D+1))
                        settlePeriod: 4,
                        //开户许可证（照片）
                        openingLicenseAccountPhoto: "",
                        //商户收单协议照片
                        acquiringAgreementPhoto: "",
                        //结算授权书（照片）
                        settleAuthLetterPhoto: "",
                        //银行卡正面照
                        bankCardPhotoFront: "",
                        //银行卡背面照
                        bankCardPhotoBack: "",
                        //开户银行
                        openBank: "",
                        //开户支行
                        openSubBank: "",
                        //开户行联行号
                        openBankCode: "",
                        //银行预留手机号
                        openBankReservePhone: "",
                        //被授权人证件号码(settleAccountType=3 时必填)
                        authorizedPersonCertNo: "",
                        //被授权人证件类型(1：身份证；2：台胞证；3：港澳通行证；4：其他settleAccountType=3 时必填)
                        authorizedPersonCertType: 1,
                        //被授权人证件正面照(settleAccountType=3 时必填)
                        authorizedCertPhotoFront: "",
                        //被授权人证件背面照 (settleAccountType=3 时选填)
                        authorizedCertPhotoBack: ""
                    },
                    //手续费扣率
                    rate: {
                        // T0
                        t0: "",
                        // T1
                        t1: "",
                        // D0
                        d0: "",
                        // D1
                        d1: "",
                        //银行卡费交易金额大于 1000 元的费率
                        bankCardRateLevel1: {
                            //银联手续费率(借记)
                            feeRateUnionpayDebit: "",
                            //银联手续费率(贷记)
                            feeRateUnionpayDebitCap: 0,
                            //银联手续费率(贷记)
                            feeRateUnionpayCredit: ""
                        },
                        //交易金额小于（含）1000 元的费率
                        bankCardRateLevel2: {
                            //银联手续费率(借记)
                            feeRateUnionpayDebit: "",
                            //银联手续费率(贷记)
                            feeRateUnionpayDebitCap: 0,
                            //银联手续费率(贷记)
                            feeRateUnionpayCredit: ""
                        }
                    },
                    //扩展数据
                    extData: {
                        //支付码
                        payCode: "",
                        //微信用户openid
                        openid: "",
                        //系统基础商户信息
                        img: {
                            merchant_img_electronic_business_license: '',
                            merchant_img_permit_for_bank_account: '',
                            merchant_img_corporate_id_card_front: '',
                            merchant_img_corporate_id_card_obverse: '',
                            merchant_img_legal_holding_id_photo: '',
                            merchant_img_principal_id_card_front: '',
                            merchant_img_principal_id_card_obverse: '',
                            merchant_img_holding_photo: '',
                            merchant_img_holding_bank_card: '',
                            merchant_img_bank_card: '',
                            merchant_img_door_shot: '',
                            merchant_img_shop_interior: '',
                            merchant_img_checkout_counter: '',
                            merchant_img_authorization_statement: '',
                            merchant_img_information_form: '',
                            merchant_img_agreement: '',
                            //店外景
                            merchant_img_store_photo:""
                        }
                    }
                }
            }
        },
        created() {
            console.log('this.$route.params', this.$route.params);
            console.log('this.$route.query', this.$route.query);
            var pay_code = this.$route.query.pay_code;
            if (this.$route.query.pay_code) {
                this.form.extData.payCode = pay_code;
                VueCookie.set('payCode', pay_code);
            } else {
                var payCode = VueCookie.get('payCode');
                if (payCode) {
                    this.form.extData.payCode = payCode;
                } else {
                    Dialog.alert({
                        title: '提示',
                        message: '支付码未获取成功，请重新扫码',
                    }).then(() => {
                    });
                }
            }

            //
            var openid = VueCookie.get('openid');
            this.form.extData.openid = openid;
            //获取微信js
            this.getWechatJs();

            //商户类型
            this.getOption('merchantType');
            //商户MCC
            this.getOption('industryCategoryId');
            //结算账户类型
            this.getOption('settleAccountType');
            //获取省级别银行网点信息
            this.getProvinceBanks(1);

        },
        methods: {
            //表单提交
            onSubmit() {
                console.log('form', this.form);
                this.$http.post('/wechat/api.merchant/addUnionMerchant', {
                    params: this.form
                }).then(function (response) {
                    console.log('response', response);
                    if (response && response.data.code == 200) {
                        Toast.success('进件成功');
                    } else {
                        Dialog.alert({
                            title: '温馨提示',
                            message: response.data.msg
                        }).then(() => {
                            // on close
                        });
                    }

                });
            },
            //请求失败
            onFailed() {

            },
            //获取初始化数据
            getOption(field) {
                var that = this;
                this.$http.get('/wechat/api.common/getUnionOption', {
                    params: {
                        field: field
                    }
                }).then(function (response) {
                    console.log('response', response.data.data);
                    that[field] = response.data.data;
                });
            },
            //通用图片上传处理
            openPhoto(field) {
                var that = this;
                wx.chooseImage({
                    // 默认9
                    count: 1,
                    // 可以指定是原图还是压缩图，默认二者都有
                    sizeType: ['original', 'compressed'],
                    // 可以指定来源是相册还是相机，默认二者都有
                    sourceType: ['album', 'camera'],
                    success: function (res) {
                        var toast = Toast.loading({
                            duration: 0,
                            message: '处理中',
                            forbidClick: true,
                            loadingType: 'spinner',
                        });
                        wx.getLocalImgData({
                            localId: res.localIds[0], // 图片的localID
                            success: function (resData) {

                                var localData = resData.localData;
                                if (localData.indexOf('data:image') != 0) {
                                    //判断是否有这样的头部
                                    localData = 'data:image/jpeg;base64,' + localData
                                }
                                localData = localData.replace(/\r|\n/g, '').replace('data:image/jgp', 'data:image/jpeg');


                                //alert(JSON.stringify(res));
                                //传递数据
                                that.$http.post('/wechat/api.merchant/uploadUnionImg',
                                    {
                                        'localId': res.localIds[0],
                                        'type': field,
                                        'localData': localData
                                    }
                                ).then(response => {
                                    toast.clear();
                                    switch (field) {
                                        //营业执照
                                        case 'businessLicensePhoto':
                                            Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});

                                            //赋值图片
                                            that.imgs.businessLicensePhoto = Config.baseURL + response.data.local_img;
                                            //更改本地图片地址
                                            that.form.extData.img.merchant_img_electronic_business_license = response.data.local_img;


                                            //商户经营名称
                                            that.form.paper.businessLicenseName = response.data.data.name;
                                            //营业执照号
                                            that.form.paper.businessLicenseCode = response.data.data.reg_num;
                                            //经营地址 ok
                                            that.form.paper.businessAddress = response.data.data.address;
                                            //营业执照图片赋值 ok
                                            that.form.paper.businessLicensePhoto = response.data.path;

                                            if (response.data.data.valid_period == "29991231") {
                                                //结束日期
                                                that.form.paper.businessLicenseExpired = '长期';
                                                //选中长期按钮
                                                that.isLicenseEnd = true;
                                            } else {
                                                //结束日期
                                                that.form.paper.businessLicenseExpired = response.data.data.valid_period;
                                            }
                                            break;
                                        //法人证件正面照
                                        case 'lawyerCertPhotoFront':
                                            //赋值图片
                                            that.imgs.lawyerCertPhotoFront = Config.baseURL + response.data.local_img;
                                            //法人姓名
                                            that.form.paper.lawyerName = response.data.data.name;
                                            //联系人姓名
                                            that.form.paper.contactPerson = response.data.data.name;
                                            //法人证件号
                                            that.form.paper.lawyerCertNo = response.data.data.num;

                                            //更改本地图片地址(法人身份证正面)
                                            that.form.extData.img.merchant_img_corporate_id_card_front = response.data.local_img;
                                            //更改本地图片地址
                                            that.form.extData.img.merchant_img_electronic_business_license = response.data.local_img;
                                            toast.clear();
                                            Notify({type: 'success', message: 'OCR识别成功，如有错误请核对后更改'});
                                            break;
                                        //法人证件背面照
                                        case 'lawyerCertPhotoBack':
                                            //赋值图片
                                            that.imgs.lawyerCertPhotoBack = Config.baseURL + response.data.local_img;
                                            //法人证件背面照
                                            that.form.paper.lawyerCertPhotoBack = res.data.path;
                                            //更改本地图片地址(负责人正面)
                                            that.form.extData.img.merchant_img_corporate_id_card_obverse = response.data.local_img;
                                            break;
                                        //门店门头照
                                        case 'storeHeadPhoto':
                                            //赋值图片
                                            that.imgs.storeHeadPhoto = Config.baseURL + response.data.local_img;
                                            that.form.paper.storeHeadPhoto = response.data.path;
                                            //更改本地图片地址(门头照)
                                            that.form.extData.img.merchant_img_door_shot = response.data.local_img;
                                            break;
                                        //门店外景照
                                        case 'storeShopPhoto':
                                            //赋值图片
                                            that.imgs.storeShopPhoto = Config.baseURL + response.data.local_img;
                                            that.form.paper.storeShopPhoto = response.data.path;
                                            //更改本地图片地址(室内景)
                                            that.form.extData.img.merchant_img_store_photo = response.data.local_img;
                                            break;
                                            //门店内景照
                                        case 'storeHallPhoto':
                                            //赋值图片
                                            that.imgs.storeHallPhoto = Config.baseURL + response.data.local_img;
                                            that.form.paper.storeHallPhoto = response.data.path;
                                            //更改本地图片地址(门店内景照)
                                            that.form.extData.img.merchant_img_shop_interior = response.data.local_img;

                                            break;
                                            //门店收银台照
                                        case 'storeCashierPhoto':
                                            //赋值图片
                                            that.imgs.storeCashierPhoto = Config.baseURL + response.data.local_img;
                                            //门店收银台照
                                            that.form.paper.storeCashierPhoto = response.data.path;
                                            //更改本地图片地址(门店收银台照)
                                            that.form.extData.img.merchant_img_checkout_counter = response.data.local_img;
                                            break;
                                            //开户许可证（照片）
                                        case 'openingLicenseAccountPhoto':
                                            //赋值图片
                                            that.imgs.openingLicenseAccountPhoto = Config.baseURL + response.data.local_img;
                                            //开户许可证
                                            that.form.paper.openingLicenseAccountPhoto = res.data.path;
                                            //更改本地图片地址(开户许可证)
                                            that.form.extData.img.merchant_img_permit_for_bank_account = response.data.local_img;
                                            break;

                                        default:
                                            break;
                                    }

                                }).catch(err => {
                                    console.error("err", err);
                                });


                            }
                        });
                    }
                });
            },
            //获取微信js
            getWechatJs() {
                Toast.loading({
                    message: '加载中...',
                    forbidClick: true,
                    loadingType: 'spinner',
                });
                this.$http.post('/wechat/api.common/getWechatJs', {
                    url: window.location.href
                }).then(function (response) {
                    Toast.clear();
                    console.log('response', response);
                    if (response.data && response.data.code == 200) {
                        wx.config(JSON.parse(response.data.data));
                    }
                })
            },
            //商户类型选择确定 ok
            onMerchantTypeConfirm(value) {
                console.log('value', value);
                this.form.paper.merchantType = value.value;
                this.merchantTypeValue = value.text;
                this.showMerchantTypePicker = false;
            },
            //商户类型选择确定 ok
            onIndustryCategoryIdConfirm(value) {
                console.log('value', value);
                this.form.paper.industryCategoryId = value.value;
                this.industryCategoryIdValue = value.text;
                this.showIndustryCategoryIdPicker = false;
            },
            //显示营业执照有效期选择
            showLicenseEndPickerClick() {
                if (!this.isLicenseEnd) {
                    this.showLicenseEndPicker = true;
                }
            },
            //营业执照注册结束日期(企业必填)格式：20150922，永久有效:长期
            onLicenseEndConfirm(value) {
                this.form.paper.businessLicenseExpired = this.dateFormatter(value);
                this.showLicenseEndPicker = false;
            },
            //地址确认
            onAddressConfirm(value) {
                console.log('value', value);
                this.form.provinceCode_cityCode_areaCode = value.map((item) => item.name).join('/');
                this.form.paper.province = value[0].name;
                this.form.paper.city = value[1].name;
                this.form.paper.area = value[2].name;
                this.showAddressPicker = false;
            },
            //结算账户类型确认
            onSettleAccountTypePickerConfirm(value) {
                console.log(value);
                this.form.paper.settleAccountType = value.value;
                this.settleAccountTypeValue = value.text;
                this.settleAccountTypePicker = false;
            },
            //银行网点省
            onProvinceBanksConfirm(value) {
                console.log('value', value);
                this.provinceBanksVal = value;
                this.showProvinceBanksPicker = false;
                this.cityBanksVal = "";
                this.getProvinceBanks(2, value);
            },
            //银行网点市
            onCityBanksConfirm(value) {
                console.log('value', value);
                this.cityBanksVal = value;
                this.showCityBanksPicker = false;
                this.getProvinceBanks(3, value);
            },
            //获取省级别银行网点信息
            getProvinceBanks(level, city = '') {
                this.$http.get('/wechat/api.common/getLeshuazfBanks', {
                    params: {
                        level: level,
                        city: city
                    }
                }).then(function (response) {
                    console.log('response', response);
                    switch (level) {
                        case 1:
                            this.provinceBanks = response.data.data;
                            break;
                        case 2:
                            this.cityBanks = response.data.data;
                            break;
                        case 3:
                            break;
                    }

                });
            },
            //银行选中
            banksSelected(col) {
                console.log('col', col);
                this.showOpenSubBankPicker = false;
                this.openSubBankValueText = col.address;
                this.form.paper.openBankCode = col.address;
                this.form.paper.openSubBank = col.banking;
            },
            //日期格式化
            dateFormat(dateString) {
                var pattern = /(\d{4})(\d{2})(\d{2})/;
                return this.trim(dateString.replace(pattern, '$1$2$3'));
            },
            //日期格式化
            dateFormatter(date) {
                var Y = date.getFullYear();
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1);
                var D = date.getDate() < 10 ? '0' + date.getDate() + ' ' : date.getDate() + ' ';
                return Y + M + D;
            },
            //左侧返回
            onClickLeft() {
                this.$router.push("/Gangway");
            }
        },
        watch: {
            //监听是否标记营业执照结束日期
            isLicenseEnd(val) {
                if (val) {
                    this.form.paper.businessLicenseExpired = '长期'
                } else {
                    this.form.paper.businessLicenseExpired = '';
                }
            },
            //银行选择值
            openSubBankValue(val) {
                this.$http.get('/wechat/api.common/searchLeshuazfBanks', {
                    params: {
                        province: this.provinceBanksVal,
                        city: this.cityBanksVal,
                        banks_text: val
                    }
                }).then(function (response) {
                    // console.log('response', response);
                    this.banksData = response.data.data;
                });

            },
        }
    }
</script>

<style scoped>
    .pay_code {
        margin-bottom: 0.1rem;
    }
</style>